import React, { FC } from 'react';
import './Breadcrumb.scss';
import { MenuModel } from '../../models/MenuModel';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../providers/AuthProvider';

interface BreadcrumbProps { }

const Breadcrumb: FC<BreadcrumbProps> = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { userLogged } = useAuth();

  const findPath = (items: MenuModel[], parentPath: string = '', breadcrumbs: { name: string; path: string | null }[]): boolean => {
    for (const item of items) {
      const fullPath = parentPath + (item.layout || item.path_name || '');

      if (fullPath === currentPath) {
        breadcrumbs.push({
          name: item.name,
          path: item.collapse ? null : fullPath
        });
        return true;
      }

      if (item.children && item.children.length > 0) {
        if (item.collapse) {
          breadcrumbs.push({
            name: item.name,
            path: null
          });
        }

        if (findPath(item.children, fullPath, breadcrumbs)) {
          return true;
        }

        if (item.collapse) {
          breadcrumbs.pop();
        }
      }
    }
    return false;
  };

  const findBreadcrumbPaths = () => {
    const breadcrumbs: { name: string; path: string | null }[] = [];
    findPath(userLogged?.menu || [], '', breadcrumbs);
    return breadcrumbs;
  };

  const breadcrumbItems = findBreadcrumbPaths();

  // "Gerenciar Financeiras" não vem do menu do backend (ver Sidebar.tsx).
  if (breadcrumbItems.length === 0 && currentPath === '/simulation-financials/list') {
    breadcrumbItems.push({ name: 'Gerenciar Financeiras', path: null });
  }

  const currentPage = breadcrumbItems[breadcrumbItems.length - 1]?.name || '';

  if (breadcrumbItems.length === 0) {
    return null;
  }

  return (
    <div className="Breadcrumb mt-2" data-testid="Breadcrumb">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb bg-transparent mb-0 pb-0 pt-1 px-0 me-sm-6 me-5">
          <li className="breadcrumb-item text-sm">
            <Link className="text-white" to="/">
              {/* <i className="ni ni-box-2"></i> */}
            </Link>
          </li>

          {breadcrumbItems.slice(0, -1).map((item, index) => (
            <li key={index} className="breadcrumb-item text-sm text-white">
              {item.path ? (
                <Link className="opacity-5 text-white" to={item.path}>
                  {item.name}
                </Link>
              ) : (
                <span className="opacity-5 text-white">{item.name}</span>
              )}
            </li>
          ))}

          <li className="breadcrumb-item text-sm text-white active" aria-current="page">
            {currentPage}
          </li>
        </ol>

        {/* <h6 className="font-weight-bolder mb-0 text-white">{currentPage}</h6> */}
      </nav>
    </div>
  )
};

export default Breadcrumb;
